import { request } from './request'

export function getCaptcha() {
  return request.get('/auth/captcha')
}

export function login(payload) {
  return request.post('/auth/login', payload)
}

export function register(payload) {
  return request.post('/auth/register', payload)
}

export function logout() {
  return request.post('/auth/logout')
}

export function queryLoginStatus() {
  return request.get('/auth/status')
}

export function updateAvatar(avatarFilename) {
  return request.put('/user/profile/avatar', { avatarFilename })
}
